/* SK Calculator — calorie & macro maths + UI. Mifflin–St Jeor (Katch–McArdle when
   body-fat % given) → activity TDEE → goal adjustment → macro split, water, fibre.
   Populates the dark results panel and highlights the matching plan. */
(function () {
  function init(root) {
    if (root.dataset.skBound) return;
    root.dataset.skBound = '1';
    var $ = function (s) { return root.querySelector(s); };
    var valEl = $('#workoutVal');

    function pressed(name) {
      var b = root.querySelector('[data-seg="' + name + '"][aria-pressed="true"]');
      return b ? b.dataset.val : null;
    }
    function setUnits(units) {
      var imp = units === 'imperial';
      var wu = root.querySelector('[data-unit="weight"]'); if (wu) wu.textContent = imp ? 'lb' : 'kg';
      var hm = root.querySelector('[data-height="metric"]'); if (hm) hm.hidden = imp;
      var hi = root.querySelector('[data-height="imperial"]'); if (hi) hi.hidden = !imp;
    }
    function num(v) { v = parseFloat(v); return isNaN(v) ? 0 : v; }
    function fmt(n) { return Math.round(n).toLocaleString('en-NZ'); }
    function setText(sel, t) { var el = root.querySelector(sel); if (el) el.textContent = t; }
    function setWidth(sel, pct) { var el = root.querySelector(sel); if (el) el.style.width = pct + '%'; }

    var goalLabels = { lose: 'To lose weight', 'lose-fast': 'To lose fast', maintain: 'To maintain', build: 'To build muscle', 'gain-fast': 'To gain fast' };

    /* segmented toggles */
    root.querySelectorAll('.seg').forEach(function (group) {
      group.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          if (btn.dataset.seg === 'units') setUnits(btn.dataset.val);
        });
      });
    });

    /* workouts stepper (0–7) */
    var stepper = $('#workoutStepper');
    if (stepper && valEl) {
      var minus = stepper.querySelector('[data-step="-1"]'), plus = stepper.querySelector('[data-step="1"]');
      var sync = function () { var v = parseInt(valEl.textContent, 10) || 0; if (minus) minus.disabled = v <= 0; if (plus) plus.disabled = v >= 7; };
      stepper.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (parseInt(valEl.textContent, 10) || 0) + parseInt(b.dataset.step, 10);
          v = Math.max(0, Math.min(7, v)); valEl.textContent = v; sync();
        });
      });
      sync();
    }

    /* goal label live */
    var goalSel = $('#goal'), forGoal = root.querySelector('.for-goal');
    if (goalSel && forGoal) goalSel.addEventListener('change', function () { forGoal.textContent = goalLabels[goalSel.value] || 'To maintain'; });

    /* calculate */
    var form = $('#calcForm');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var imp = pressed('units') === 'imperial', gender = pressed('gender') || 'female';
      var age = num($('#age').value), bf = num($('#bodyfat').value);
      var weight = num($('#weight').value), kg = imp ? weight / 2.2046226 : weight;
      var cm;
      if (imp) { cm = (num($('#heightFt').value) * 12 + num($('#heightIn').value)) * 2.54; }
      else { cm = num($('#height').value); }
      if (age <= 0 || kg <= 0 || cm <= 0) {
        (age <= 0 ? $('#age') : (kg <= 0 ? $('#weight') : (imp ? $('#heightFt') : $('#height')))).focus();
        return;
      }
      var workouts = valEl ? (parseInt(valEl.textContent, 10) || 0) : 0;
      var activity = $('#activity').value, goal = goalSel ? goalSel.value : 'maintain';

      var bmr;
      if (bf > 0 && bf < 70) { bmr = 370 + 21.6 * (kg * (1 - bf / 100)); }            // Katch–McArdle
      else { bmr = gender === 'male' ? (10 * kg + 6.25 * cm - 5 * age + 5) : (10 * kg + 6.25 * cm - 5 * age - 161); } // Mifflin–St Jeor

      var base = { sedentary: 1.2, light: 1.375, moderate: 1.55, very: 1.725, athlete: 1.9 }[activity] || 1.55;
      var tdee = bmr * Math.min(2.0, base + workouts * 0.01);
      var kcal = tdee * ({ lose: 0.80, 'lose-fast': 0.70, maintain: 1.0, build: 1.10, 'gain-fast': 1.20 }[goal] || 1.0);

      var split = { lose: { p: 40, c: 30, f: 30 }, 'lose-fast': { p: 42, c: 28, f: 30 }, maintain: { p: 30, c: 40, f: 30 }, build: { p: 30, c: 45, f: 25 }, 'gain-fast': { p: 28, c: 47, f: 25 } }[goal] || { p: 30, c: 40, f: 30 };

      setText('#sk-calc-kcal', fmt(kcal));
      setText('#sk-calc-bmr', fmt(bmr));
      setText('#sk-calc-tdee', fmt(tdee));
      if (forGoal) forGoal.textContent = goalLabels[goal] || 'To maintain';
      setText('#sk-calc-pg', fmt(kcal * split.p / 100 / 4)); setWidth('#sk-calc-pb', split.p); setText('#sk-calc-pp', split.p + '% of intake');
      setText('#sk-calc-cg', fmt(kcal * split.c / 100 / 4)); setWidth('#sk-calc-cb', split.c); setText('#sk-calc-cp', split.c + '% of intake');
      setText('#sk-calc-fg', fmt(kcal * split.f / 100 / 9)); setWidth('#sk-calc-fb', split.f); setText('#sk-calc-fp', split.f + '% of intake');
      setText('#sk-calc-water', (kg * 0.035 + workouts * 0.1).toFixed(1) + ' L');
      setText('#sk-calc-fibre', Math.round(kcal / 1000 * 14) + ' g');
      var foot = $('#sk-calc-foot'); if (foot) foot.textContent = 'Your estimated daily targets. Tweak any input and recalculate.';

      /* ── Match a Weekly Box tier from EVERYTHING entered ──
         kcal already integrates gender, age, height, weight, body-fat, activity, workouts
         and goal, so it is our "how big should each meal be" signal. Goal sets the lane;
         the maths sizes it:
           • Cutting (lose / lose fast)  → Lifestyle  — lean, calorie-controlled, high-protein
           • Building (build / gain fast) → Recovery   — high-protein, bigger, for muscle
           • Maintaining:
               – trains hard (very / athlete / 6+ workouts) → Performance — carb fuel
               – else bigger daily need → Recovery (larger, more filling); lighter → Lifestyle */
      var growing    = (goal === 'build' || goal === 'gain-fast');
      var cutting    = (goal === 'lose'  || goal === 'lose-fast');
      var trainsHard = (activity === 'very' || activity === 'athlete' || workouts >= 6);
      var BIG_DAY = 2100; // kcal/day above which a maintainer needs the larger box
      var key;
      if (cutting)         { key = 'lifestyle'; }
      else if (growing)    { key = 'recovery'; }
      else if (trainsHard) { key = 'performance'; }
      else                 { key = (kcal >= BIG_DAY) ? 'recovery' : 'lifestyle'; }
      var matchedCard = null;
      root.querySelectorAll('.plan').forEach(function (p) {
        var m = p.getAttribute('data-plan-key') === key;
        if (m) matchedCard = p;
        p.classList.toggle('matched', m);
        var rb = p.querySelector('.ribbon'); if (rb) rb.hidden = !m;
      });

      /* surface the in-results CTA → Weekly Box, tier pre-selected */
      var cta = $('#sk-calc-cta');
      if (cta) {
        var href = cta.getAttribute('href') || '/products/the-weekly-box';
        var hash = '', hi = href.indexOf('#'); if (hi > -1) { hash = href.slice(hi); href = href.slice(0, hi); }
        var bits = href.split('?'), path = bits[0];
        var params = new URLSearchParams(bits[1] || '');
        params.set('view', 'weekly-box');  // the box's template isn't assigned yet — force the real view
        params.set('tier', key);           // pre-select the matched tier
        cta.setAttribute('href', path + '?' + params.toString() + hash);
        cta.setAttribute('data-tier', key);
        var nameEl = matchedCard ? matchedCard.querySelector('.p-name') : null;
        var calEl = matchedCard ? matchedCard.querySelector('.p-cal') : null;
        setText('#sk-calc-cta-plan', nameEl ? nameEl.textContent.trim() : 'Weekly');
        setText('#sk-calc-cta-cal', calEl ? '· ' + calEl.textContent.trim() : '');
        cta.hidden = false;
      }

      /* ── stash the numbers + surface the custom-plan CTA (round-trip with the intake form) ── */
      try {
        sessionStorage.setItem('sk:calc', JSON.stringify({
          cal: Math.round(kcal),
          p: Math.round(kcal * split.p / 100 / 4),
          c: Math.round(kcal * split.c / 100 / 4),
          f: Math.round(kcal * split.f / 100 / 9)
        }));
      } catch (e) {}
      var planCta = $('#sk-calc-plan-cta');
      if (planCta) {
        var ret = null; try { ret = sessionStorage.getItem('sk:intake-return'); } catch (e) {}
        var fromIntake = !!ret || /[?&]from=custom-plan/.test(location.search);
        if (ret) planCta.setAttribute('href', ret);
        setText('#sk-calc-plan-label', fromIntake ? 'Back to your custom plan' : 'Start a custom meal plan');
        setText('#sk-calc-plan-sub', fromIntake ? 'Your progress is saved. We’ll drop these numbers in.' : 'Use these numbers for meals made to your spec.');
        planCta.hidden = false;
      }

      if (window.matchMedia('(max-width: 939px)').matches) {
        if (window.skScrollToEl) window.skScrollToEl($('#results'), 'start');
      }
    });
  }
  document.querySelectorAll('.sk-calculator').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.sk-calculator') : null; if (el) init(el);
  });
})();
